// GalleryPage.jsx
import React from "react";
import NavBar from "../components/common/NavBar";
import Footer from "../components/common/Footer";
import CustomSlider from "./CustomSlider"; // Update the path accordingly
import TopImage from "../components/common/TopImage";

const GalleryPage = () => {
  // Define your images and title for each gallery
  const gallery1Images = ["I1.JPG", "I2.JPG", "I3.JPG", "I4.JPG", "I5.JPG", "I6.JPG", "I7.JPG", "I8.JPG", "I9.JPG", "I10.JPG"];
  const gallery2Images = ["P1.jpeg", "P2.jpeg", "P3.jpeg", "P4.jpeg",];
  const gallery3Images = ["PP1.jpeg", "PP2.jpeg", "PP3.jpeg", "PP4.jpeg", "PP5.jpeg", "PP6.jpeg"];
  const gallery4Images = ["TP1.JPG", "TP2.jpeg", "TP3.jpeg", "TP4.JPG", "TP5.jpeg", "TP6.JPG"];
  const gallery5Images = ["S1.JPG", "S2.JPG", "S3.JPG", "S4.JPG", "S5.JPG", "S6.JPG", "S7.JPG", "S8.JPG", "S9.JPG", "S10.JPG", "S11.JPG", "S12.JPG"];
  const gallery6Images = ["E1.JPG", "E2.JPG", "E3.JPG", "E4.JPG"];
  // Add more galleries as needed

  return (
    <div>
      <NavBar />
      <TopImage text="Gallery Page"/>
      <div>
    <p className="font-dm-sans text-sm mb-20 mx-28 max-md:mx-5 mt-20 text-gray-700 sm:text-base  font-normal leading-6 sm:leading-7 tracking-tight text-justify ">
      At Motherland Children Academy, we understand that parents want the best for their child, and that's why we are all about giving your child a quality life. From a strong academic foundation to the development of your child's physical, spiritual, and emotional personality, the Motherland way is about holistic development in its true sense.
    </p>  
  </div>
      <div className="mt-48 sm:mt-20">
        <CustomSlider images={gallery1Images} title="Independence Day" imageWidth="350px" imageHeight="200px" />
        <CustomSlider images={gallery2Images} title="School Picnic" imageWidth="350px" imageHeight="200px" />
        <CustomSlider images={gallery3Images} title="Pre Primary" imageWidth="350px" imageHeight="200px" />
        <CustomSlider images={gallery4Images} title="Tree Plantation" imageWidth="350px" imageHeight="200px"/>
        <CustomSlider images={gallery5Images} title="Sports Day" imageWidth="350px" imageHeight="200px" />
        <CustomSlider images={gallery6Images} title="Science Exhibtion" imageWidth="350px" imageHeight="200px"/>
        {/* Add more galleries as needed */}
      </div>
      <Footer />
    </div>
  );
};

export default GalleryPage;
